import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="scent-wave min-h-[calc(100vh-4rem)] flex items-center justify-center p-8">
      <div className="max-w-md w-full bg-white rounded-3xl border border-slate-200 p-10 text-center">
        <XCircle className="w-16 h-16 mx-auto text-slate-300" />
        <h1 className="mt-4 font-serif text-3xl text-[#0A1128]">Payment Canceled</h1>
        <p className="mt-2 text-slate-500 text-sm">No charge was made. You can try again anytime.</p>
        <Link to="/host">
          <Button className="mt-6 rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white" data-testid="cancel-back-host">Back to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
